import { __extends } from "tslib";
import { getShadowElement } from '@tyler-components-web/core';
import { BaseAdapter } from '../core/adapters/base-adapter';
import { OPEN_ICON_CONSTANTS } from './open-icon-constants';
import { ICON_CONSTANTS } from '../icon';
import { toggleClass } from '../core';
var OpenIconAdapter = /** @class */ (function (_super) {
    __extends(OpenIconAdapter, _super);
    function OpenIconAdapter(component) {
        var _this = _super.call(this, component) || this;
        _this._openIcon = getShadowElement(component, "." + OPEN_ICON_CONSTANTS.classes.ICON);
        _this._iconElement = getShadowElement(component, ICON_CONSTANTS.elementName);
        return _this;
    }
    OpenIconAdapter.prototype.setOrientation = function (orientation) {
        if (orientation === OPEN_ICON_CONSTANTS.strings.ORIENTATION_HORIZONTAL) {
            this._iconElement.name = 'keyboard_arrow_right';
        }
        else {
            this._iconElement.name = 'keyboard_arrow_down';
        }
    };
    OpenIconAdapter.prototype.setOpenState = function (open) {
        toggleClass(this._openIcon, open, OPEN_ICON_CONSTANTS.classes.ICON_OPEN);
    };
    return OpenIconAdapter;
}(BaseAdapter));
export { OpenIconAdapter };
